
import React from 'react';


import {
	createPayment_69fce3d85276935741630b32,
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_carriton0fqi,
} from '../../actions/auth.actions';


import './ubicaciones6ua1kh.scss';


const loftyShouldRenderCarousel = (products = []) => {
  const loftyIsMobile = window.innerWidth < 464;
  if (loftyIsMobile) {
    return true;
  }
  return products.length > 3;
}


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pubicaciones6ua1kh = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_carriton0fqi,
	set_lofty_global_carriton0fqi_app,

}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id69cd79ddee7dda37b6dc7999" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iacot" className="">
      
        <a
          target=""
          className=""
          id="i6edva"
          href="/"
        >
          
    <div id="iysqr8" className="">
    <>Inicio</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iy44bl"
          href="/menu"
        >
          
    <div id="i41p5g" className="">
    <>Menú</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iyf8jb"
          href="/eventos"
        >
          
    <div id="iztdq8" className="">
    <>Reservaciones</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i377lh"
          href="/unite"
        >
          
    <div id="io6x2g" className="">
    <>Únete a nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i3knlt"
          href="/ubicaciones"
        >
          
    <div id="ie1esj" className="">
    <>Ubicaciones</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="inff1e" className="">
      
        <a
          target=""
          className=""
          id="ijhswy"
          href="/carrito"
        >
          
    <div id="i7kn2y" className="">
    <>Carrito</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Menú</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Reservaciones</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Únete a nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Ubicaciones</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Carrito</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ihk8" className="">
      
      <div id="iym0il" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        <>Nuestras Ubicaciones</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i803s">
        <>Visítanos en cualquiera de nuestros locales</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i3dh" className="">
      
      <div className="" id="iiaa8f">
        <>Encuéntranos</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ijh55q">
        <>Estamos Cerca de Ti</>
      <br className="" id="" />
      
      </div>
      
      <div id="iiainz" className="">
      
      <div className="" id="ilhnie">
        <>Contamos con múltiples ubicaciones estratégicas para servirte mejor. Cada local ofrece la misma calidad y sabor que nos caracteriza.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <iframe
        title="Mapa"
        className=""
        id="i8or8v"
        frameBorder="0"
        src={`https://maps.google.com/maps?&q=13°57'34.8"N 87°12'46.5"W&z=15&t=q&output=embed`}
      />
      <>
        </>
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div className="" id="iyo7r6">
        <>Sabores auténticos de Honduras. Tradición, calidad y amor en cada platillo.</>
      </div>
      <>
        </>
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div className="" id="i78qcc">
        <>+504 9999-9999</>
      </div>
      
      <div className="" id="il1rnw">
        <>info@correo.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_carriton0fqi_app: (value) => dispatch(set_lofty_global_carriton0fqi(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pubicaciones6ua1kh);
  